export const filterByCategories = [
    {
        name: 'By sector',
        link: '/success-stories'
    },
    {
        name: 'By role',
        link: '/success-stories/by-role'
    },
    {
        name: 'By organisation type',
        link: '/success-stories/by-organisation-type'
    }
]